import { useState } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, Copy, Star, CheckCircle } from "lucide-react";
import { toast } from "sonner";

const copyText = (text) => {
  navigator.clipboard.writeText(text);
  toast.success("Copied!");
};

const weeklyPosts = [
  {
    title: "Knotless Braids Special",
    text: "Looking for tension-free, lightweight braids? Our knotless braids start at $180 with a seamless feed-in technique that protects your edges. Book online at afromagicbraiding.shop! Walk-ins welcome.\n\n22560 Telegraph Rd, Southfield, MI 48033\nCall/Text: (313) 484-7307\n\n#KnotlessBraids #Southfield #AfricanHairBraiding #AfroMagic #MichiganBraider",
  },
  {
    title: "Boho Braids Are Here",
    text: "Boho braids = braids + curls = effortless beauty! Starting at $210, our boho knotless braids give you that free-spirited look everyone loves. Perfect for summer!\n\nBook online: afromagicbraiding.shop\n22560 Telegraph Rd, Southfield, MI 48033\n(313) 484-7307\n\n#BohoBraids #BohoKnotless #SouthfieldMI #HairBraiding #AfroMagicBraiding",
  },
  {
    title: "Men's Braids Starting at $50",
    text: "Guys, we've got you! Cornrows starting at $50, natural twists and box braids at $100. Clean, precise, and fast. Walk-ins welcome or book online.\n\nafromagicbraiding.shop\n22560 Telegraph Rd, Southfield, MI\n(313) 484-7307\n\n#MensBraids #Cornrows #SouthfieldBarber #AfroMagic #DetroitBraids",
  },
  {
    title: "Fulani Braids — A Cultural Classic",
    text: "Our Fulani braids start at $180 and feature a stunning central cornrow with side braids and accessories. A beautiful cultural style that turns heads!\n\nBook online: afromagicbraiding.shop\nWalk-ins welcome at 22560 Telegraph Rd, Southfield, MI 48033\n(313) 484-7307\n\n#FulaniBraids #AfricanBraids #Southfield #OaklandCounty #AfroMagic",
  },
  {
    title: "Kids & Adults Welcome!",
    text: "Whether it's for you or your little one, Afro Magic Braiding has styles for the whole family! From cornrows to box braids, we've got you covered.\n\nPrices start at just $50. Book online!\nafromagicbraiding.shop\n22560 Telegraph Rd, Southfield, MI 48033\n(313) 484-7307\n\n#KidsBraids #FamilyBraiding #SouthfieldMI #AfroMagic #ProtectiveStyles",
  },
  {
    title: "Faux Locs — Get the Loc Look",
    text: "Want locs without the commitment? Our faux locs start at $170 and look incredibly natural. Lightweight, stylish, and lasts 6-8 weeks!\n\nBook online: afromagicbraiding.shop\n22560 Telegraph Rd, Southfield, MI 48033\n(313) 484-7307\n\n#FauxLocs #LocStyles #SouthfieldBraids #AfroMagicBraiding #Michigan",
  },
  {
    title: "Crochet Styles — Quick & Beautiful",
    text: "Short on time? Our crochet styles start at $130 and take just 2 hours! Multiple textures available for a versatile, natural look.\n\nWalk-ins welcome or book at afromagicbraiding.shop\n22560 Telegraph Rd, Southfield, MI 48033\n(313) 484-7307\n\n#CrochetBraids #QuickStyles #Southfield #AfroMagic #AfricanHairBraiding",
  },
  {
    title: "Weekend Availability",
    text: "Weekend spots go fast! Don't wait — book your Saturday or Sunday appointment now at afromagicbraiding.shop and secure your spot.\n\nWalk-ins welcome but appointments are recommended.\n22560 Telegraph Rd, Southfield, MI 48033\n(313) 484-7307\n\n#WeekendBraids #SouthfieldMI #BookOnline #AfroMagic #HairBraidingNearMe",
  },
];

const reviewTemplates = [
  {
    title: "After completing braids",
    text: "Hi {name}! Thank you so much for choosing Afro Magic! We hope you love your new braids. If you have a moment, we'd really appreciate a Google review — it helps other people find us! Here's the link: [YOUR GOOGLE REVIEW LINK]. Thank you!",
  },
  {
    title: "Follow-up text (next day)",
    text: "Hey {name}! How are your new braids holding up? We loved having you at the salon! If you could take 30 seconds to leave us a Google review, it would mean the world to us: [YOUR GOOGLE REVIEW LINK]. Thank you!",
  },
  {
    title: "For returning clients",
    text: "Hey {name}! So great to see you again at Afro Magic! Since you keep coming back, would you mind sharing your experience with a quick Google review? It really helps us grow: [YOUR GOOGLE REVIEW LINK]. We appreciate you!",
  },
  {
    title: "With incentive",
    text: "Hi {name}! Thank you for your visit to Afro Magic! Leave us a Google review and mention this text to get $10 OFF your next appointment. Here's the link: [YOUR GOOGLE REVIEW LINK]. See you next time!",
  },
];

const reviewResponses = [
  {
    title: "Reply to 5-star review",
    text: "Thank you so much, {reviewer}! We're thrilled you loved your experience at Afro Magic Braiding. Our team takes pride in every braid, and it means the world to hear that! We look forward to seeing you again. — Afro Magic Team",
  },
  {
    title: "Reply to 4-star review",
    text: "Thank you for your kind words, {reviewer}! We're glad you enjoyed your visit. We're always working to make every experience a 5-star one — please let us know how we can do even better next time! — Afro Magic Team",
  },
  {
    title: "Reply to negative review",
    text: "Thank you for your feedback, {reviewer}. We're sorry your experience didn't meet expectations. We take every concern seriously — please call us at (313) 484-7307 so we can make it right. Your satisfaction is our priority. — Afro Magic Team",
  },
];

const directoryLinks = [
  { name: "Google Business Profile", url: "https://business.google.com", desc: "Most important for local ranking" },
  { name: "Yelp for Business", url: "https://biz.yelp.com", desc: "Claim your free listing" },
  { name: "Facebook Business Page", url: "https://www.facebook.com/business", desc: "Create a business page" },
  { name: "Apple Maps (Apple Business Connect)", url: "https://businessconnect.apple.com", desc: "Get on Apple Maps" },
  { name: "Bing Places", url: "https://www.bingplaces.com", desc: "Get on Bing search" },
];

const GoogleSEOPage = () => {
  const [copiedIdx, setCopiedIdx] = useState(null);

  const handleCopy = (text, idx) => {
    copyText(text);
    setCopiedIdx(idx);
    setTimeout(() => setCopiedIdx(null), 2000);
  };

  return (
    <div className="min-h-screen bg-brand-bg" data-testid="google-seo-page">
      <header className="border-b border-brand-border bg-brand-surface px-6 py-4 flex items-center justify-between">
        <Link to="/" className="font-serif text-xl text-brand-text">Afro <span className="text-brand-gold">Magic</span></Link>
        <Link to="/admin" className="flex items-center gap-1 font-sans text-xs text-brand-text-muted hover:text-brand-gold"><ArrowLeft size={14} /> Dashboard</Link>
      </header>

      <div className="max-w-4xl mx-auto px-6 py-10">
        <h1 className="font-serif text-3xl text-brand-text mb-2">Google Ranking Toolkit</h1>
        <p className="font-sans text-sm text-brand-text-muted mb-10">Ready-to-use posts, review templates, and directory links to boost your Google ranking</p>

        {/* Weekly Google Business Posts */}
        <section className="mb-12">
          <h2 className="font-serif text-xl text-brand-gold mb-1">Weekly Google Business Posts</h2>
          <p className="font-sans text-xs text-brand-text-muted mb-4">Copy and paste these to your Google Business Profile every week. Post with a photo of your work for best results.</p>
          <div className="space-y-3">
            {weeklyPosts.map((post, i) => (
              <div key={post.title} className="border border-brand-border bg-brand-surface p-4" data-testid={`gbp-post-${i}`}>
                <div className="flex items-center justify-between mb-2">
                  <p className="font-sans text-sm text-brand-gold font-semibold">Week {i + 1}: {post.title}</p>
                  <button onClick={() => handleCopy(post.text, `post-${i}`)} className="flex items-center gap-1 px-3 py-1 text-xs font-sans border border-brand-border text-brand-text-muted hover:border-brand-gold hover:text-brand-gold transition-colors">
                    {copiedIdx === `post-${i}` ? <><CheckCircle size={12} /> Copied!</> : <><Copy size={12} /> Copy</>}
                  </button>
                </div>
                <p className="font-sans text-xs text-brand-text-muted whitespace-pre-line leading-relaxed">{post.text}</p>
              </div>
            ))}
          </div>
        </section>

        {/* Review Request Templates */}
        <section className="mb-12">
          <h2 className="font-serif text-xl text-brand-gold mb-1">Review Request Templates</h2>
          <p className="font-sans text-xs text-brand-text-muted mb-4">Text or DM these to clients after their appointment. Replace {"{name}"} and add your Google review link.</p>
          <div className="space-y-3">
            {reviewTemplates.map((tmpl, i) => (
              <div key={tmpl.title} className="border border-brand-border bg-brand-surface p-4" data-testid={`review-tmpl-${i}`}>
                <div className="flex items-center justify-between mb-2">
                  <p className="font-sans text-sm text-brand-gold font-semibold">{tmpl.title}</p>
                  <button onClick={() => handleCopy(tmpl.text, `tmpl-${i}`)} className="flex items-center gap-1 px-3 py-1 text-xs font-sans border border-brand-border text-brand-text-muted hover:border-brand-gold hover:text-brand-gold transition-colors">
                    {copiedIdx === `tmpl-${i}` ? <><CheckCircle size={12} /> Copied!</> : <><Copy size={12} /> Copy</>}
                  </button>
                </div>
                <p className="font-sans text-xs text-brand-text-muted leading-relaxed">{tmpl.text}</p>
              </div>
            ))}
          </div>
        </section>

        {/* Review Response Templates */}
        <section className="mb-12">
          <h2 className="font-serif text-xl text-brand-gold mb-1">How to Reply to Reviews</h2>
          <p className="font-sans text-xs text-brand-text-muted mb-4">Google rewards businesses that reply to reviews. Use these templates. Replace {"{reviewer}"} with their name.</p>
          <div className="space-y-3">
            {reviewResponses.map((resp, i) => (
              <div key={resp.title} className="border border-brand-border bg-brand-surface p-4" data-testid={`review-resp-${i}`}>
                <div className="flex items-center justify-between mb-2">
                  <p className="font-sans text-sm text-brand-gold font-semibold">{resp.title}</p>
                  <button onClick={() => handleCopy(resp.text, `resp-${i}`)} className="flex items-center gap-1 px-3 py-1 text-xs font-sans border border-brand-border text-brand-text-muted hover:border-brand-gold hover:text-brand-gold transition-colors">
                    {copiedIdx === `resp-${i}` ? <><CheckCircle size={12} /> Copied!</> : <><Copy size={12} /> Copy</>}
                  </button>
                </div>
                <p className="font-sans text-xs text-brand-text-muted leading-relaxed">{resp.text}</p>
              </div>
            ))}
          </div>
        </section>

        {/* Directory Listings */}
        <section className="mb-12">
          <h2 className="font-serif text-xl text-brand-gold mb-1">Get Listed on Directories (FREE)</h2>
          <p className="font-sans text-xs text-brand-text-muted mb-4">Use the EXACT same info everywhere: <strong className="text-brand-text">Afro Magic Braiding Hair | 22560 Telegraph Rd, Southfield, MI 48033 | (313) 484-7307</strong></p>
          <div className="space-y-2">
            {directoryLinks.map((dir, i) => (
              <a key={dir.name} href={dir.url} target="_blank" rel="noopener noreferrer" className="flex items-center justify-between p-3 border border-brand-border hover:border-brand-gold transition-colors group" data-testid={`directory-${i}`}>
                <div>
                  <p className="font-sans text-sm text-brand-text group-hover:text-brand-gold transition-colors">{dir.name}</p>
                  <p className="font-sans text-[10px] text-brand-text-muted">{dir.desc}</p>
                </div>
                <span className="font-sans text-xs text-brand-gold">Visit &rarr;</span>
              </a>
            ))}
          </div>
        </section>

        {/* Quick Checklist */}
        <section>
          <h2 className="font-serif text-xl text-brand-gold mb-4">Your #1 Ranking Checklist</h2>
          <div className="border border-brand-gold/30 bg-brand-surface p-5 space-y-2">
            {[
              "Google Business Profile is claimed and verified",
              "Profile has 20+ photos of your braiding work",
              "NAP (Name, Address, Phone) is identical on website + Google + all directories",
              "Post on Google Business Profile every week (use templates above)",
              "Ask every client for a Google review after their appointment",
              "Reply to EVERY Google review within 24 hours",
              "Listed on Yelp, Facebook, Apple Maps, and Bing",
              "Website has all SEO schemas (DONE - already on your site)",
              "Get 20+ Google reviews with 4.5+ star average",
              "Add new photos of your work to Google Business weekly",
            ].map((item, i) => (
              <label key={item} className="flex items-start gap-3 cursor-pointer">
                <input type="checkbox" className="mt-1 w-4 h-4 accent-[#D4AF37] cursor-pointer" />
                <span className="font-sans text-sm text-brand-text-muted">{item}</span>
              </label>
            ))}
          </div>
        </section>
      </div>
    </div>
  );
};

export default GoogleSEOPage;
